import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import cls from 'clsx';
import { Right } from '@linktivity/link-icons';
import { Dialog, Skeleton } from '@linktivity/link-ui';
import BellIcon from '@link/share/assets/bell.svg?react';
import { ReactMarkdown } from '@link/share/components';
import { NotificationProps } from './Notification.types';
import styles from './notification.module.css';

const Notification: React.FC<NotificationProps> = ({
  content,
  isUnread = false,
  dialogTitle = '',
  dialogContent = '',
  className = '',
  loading = false
}) => {
  const { t } = useTranslation();
  const [isDialogVisible, setIsDialogVisible] = useState(false);

  const handleClick = () => {
    if (dialogContent) {
      setIsDialogVisible(true);
    }
  };

  const handleCloseDialog = () => {
    setIsDialogVisible(false);
  };

  if (loading) {
    return (
      <div className={cls(styles.notification, styles.skeleton, className)}>
        <Skeleton className={styles.skeletonIcon} />
        <Skeleton className={styles.skeletonContent} />
        <Skeleton className={styles.skeletonArrow} />
      </div>
    );
  }

  if (!content) {
    return null;
  }

  return (
    <>
      <button
        className={cls(styles.notification, className)}
        onClick={handleClick}
        type="button"
      >
        {isUnread && <div className={styles.unreadDot} />}

        <div className={styles.iconContainer}>
          <BellIcon />
        </div>

        <div className={styles.content}>{content}</div>

        <Right className={styles.arrowIcon} />
      </button>

      {dialogContent && (
        <Dialog
          visible={isDialogVisible}
          onClose={handleCloseDialog}
          title={dialogTitle || t('share.common.notification')}
        >
          <div className={styles.dialogContent}>
            <ReactMarkdown source={dialogContent as string} />
          </div>
        </Dialog>
      )}
    </>
  );
};

export default Notification;
